
const timeZoneMapping = {
  "-3": "America/St_Johns",
  "-4": "America/Halifax",
  "-5": "America/Toronto",
  "-6": "America/Regina",
  "-7": "America/Edmonton",
  "-8": "America/Vancouver"
}

/**
 * Helper to get a timezone string basedon the UTC offset
 * 
 * @returns string
 */
function getTimeZone( date ) {
  let timezone = '';
  if ( date && date instanceof Date ) {
    // Returns the timezone offset in hours.
    // Eg. for Edmonton this returns -7
    let timezoneOffset = ( date.getTimezoneOffset() / -60 ).toString();

      // console.log( timezoneOffset )
    if ( timeZoneMapping.hasOwnProperty( timezoneOffset ) ) {
      // console.log('in here');
      timezone = timeZoneMapping[ timezoneOffset ];
    }

  }
  return timezone;
}

function getCurrentDate() {
  const date     = new Date();
  const today    = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate();
  const time     = date.getHours().toString().padStart(2, '0') + ":" + date.getMinutes().toString().padStart(2, '0') + ":" + date.getSeconds().toString().padStart(2, '0');
  const dateTime = today +' '+ time;
  const unix     = Math.floor( date.getTime() / 1000 );

  return {
    'instance': date,
    today,
    time,
    dateTime,
    unix
  }
}


// @TODO: Put this in abstract
/**
 * String.padStart()
 * version 1.0.1
 * Feature	        Chrome  Firefox Internet Explorer   Opera	Safari	Edge
 * Basic support	57   	51      (No)	            44   	10      15
 * -------------------------------------------------------------------------------
 */
if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

export {
  getTimeZone,
  getCurrentDate
}